import { AlarmOutlined, CalendarMonth, Place } from "@mui/icons-material";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import GoBack from "../../../../../components/buttons/GoBack";
import {
  STATUS_COLOR_GROUPS,
  getStatusColor,
} from "../../../../../enums/AppointmentStatus";
import { APPOINTEMENTS } from "../../../../../enums/UrlPaths";
import useUser from "../../../../../hooks/useUser";
import { getDateObject } from "../../../../../utils/DateTimeRepository";
import { CARD_RADIUS } from "./LinkCard";

export default function HeaderCard({ appointment, actions }) {
  const { t, i18n } = useTranslation();
  const { roles } = useUser();
  const location = useLocation();
  const goBack = roles.user ? APPOINTEMENTS : location.state?.from;
  const status = appointment?.status;
  const statusColor = getStatusColor(status);
  const isWaiting = STATUS_COLOR_GROUPS.WAITING.includes(status);

  const service =
    appointment?.priceList?.translations?.[i18n.language] ||
    appointment?.priceList?.title ||
    t("NoInfo");
  const clinic = appointment?.clinic;
  const start = dayjs(getDateObject(appointment?.startDate));
  const end = dayjs(getDateObject(appointment?.endDate));

  return (
    <Paper
      sx={{
        p: 2,
        height: "100%",
        borderRadius: CARD_RADIUS,
        borderLeft: 4,
        borderLeftColor: statusColor || "divider",
      }}
    >
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <GoBack
          url={goBack}
          size="small"
          testId={"appointment.details.back-button"}
        />
        <Chip
          size="small"
          label={t(status || "PastAppointment")}
          data-testid="appointment.details.status-symbol"
          data-status={status}
          sx={{
            fontWeight: 600,
            bgcolor: statusColor || "action.selected",
            color: statusColor ? "#000" : "text.primary",
          }}
        />
        {isWaiting ? (
          <AlarmOutlined fontSize="small" sx={{ color: statusColor }} />
        ) : null}
        <Box flexGrow={1} />
        {actions}
      </Stack>

      <Typography
        variant="h6"
        fontWeight={600}
        mt={1.5}
        data-testid="appointment.details.field-Service"
      >
        {service}
      </Typography>

      <Stack spacing={1.5} mt={1.5}>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Place fontSize="small" color="primary" />
          <Typography
            variant="body2"
            data-testid="appointment.details.field-Location"
          >
            {clinic
              ? `${clinic.title} - ${clinic.streetAddress}, ${clinic.city}`
              : t("NoInfo")}
          </Typography>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <CalendarMonth fontSize="small" color="primary" />
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              data-testid="appointment.details.field-DateOfAppointment"
            >
              {start.format("DD/MM/YYYY")}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={600}
              data-testid="appointment.details.field-TimeOfAppointment"
            >
              {start.format("HH:mm") + " - " + end.format("HH:mm")}
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
}
